import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useState } from 'react';
// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  CircularProgress,
} from '@mui/material';
import axiosInstance from 'src/utils/axios';
import api from 'src/services/api';
import { useMutationCustom, useQueryCustom } from 'src/utils/reactQueryHooks';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router-dom';
import { PATH_DASHBOARD } from 'src/routes/paths';
// utils
import { fToNow } from '../../../utils/formatTime';
// _mock_
import { _notifications } from '../../../_mock';
// components
import Iconify from '../../../components/Iconify';
import Scrollbar from '../../../components/Scrollbar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const { t } = useTranslation();

  // -------------------------------------------------------- query Get
  const getApi = async () =>
    axiosInstance.get(`${api.notification?.base}`, {
      params: {
        page: 1,
        limit: 10,
        seen: 0,
      },
    });
  // ----------------------------
  const { data: { data = {} } = {}, isLoading } = useQueryCustom({
    name: `${api.notification?.base}_list`,
    url: getApi,
  });
  // -------------------------------------------------------- query Get
  const read = (params) => axiosInstance.post(`${api.notification?.base}`, params);
  const onSuccessMutating = () => {
    toast.success(t('successfully'));
  };
  const onErrorMutating = (error) => {
    const errorTitle = error.response.data.message || t('errorTryAgain');
    const errors = Object.values(error?.response?.data?.errors || {});
    if (errors?.length) {
      errors?.map((x) => {
        return toast.error(x?.[0]);
      });
    } else toast.error(errorTitle);
  };
  const resQuery = useMutationCustom({
    url: read,
    name: `${api.notification?.base}_update`,
    invalidQueries: [`${api.notification?.base}_list`, `${api.notification?.base}_all_list`],
    onSuccess: onSuccessMutating,
    //  onError: onErrorMutating,
  });

  console.log('* * * NotificationsPopover :', { data });

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleMarkAllAsRead = () => {
    resQuery.mutate({ notification_id: data?.data?.map?.((x) => x?.notification?.id) });
  };

  const handleMarkAsRead = (data) => {
    resQuery.mutate({ notification_id: [data?.notification?.id] });
  };

  return (
    <>
      <IconButtonAnimate color={open ? 'primary' : 'default'} 
        // onClick={handleOpen} 
        sx={{ width: 40, height: 40 }}
      >
        <Link to={PATH_DASHBOARD.notification.root}>
          <Badge badgeContent={data?.meta?.total} color="error">
            {/* <Iconify icon="eva:bell-outline" width={30} height={30} /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="29" viewBox="0 0 23 29" fill="none">
              <path
                d="M22.6568 18.8408L20.54 9.75681C20.1647 7.8368 19.1871 6.08643 17.7492 4.75988C16.3113 3.43334 14.488 2.59969 12.544 2.38V1.6192C12.5541 1.48735 12.5368 1.35483 12.4933 1.22995C12.4498 1.10508 12.3809 0.990546 12.291 0.893533C12.2012 0.796521 12.0922 0.719121 11.971 0.66619C11.8498 0.613258 11.719 0.585938 11.5868 0.585938C11.4545 0.585938 11.3237 0.613258 11.2025 0.66619C11.0814 0.719121 10.9724 0.796521 10.8825 0.893533C10.7927 0.990546 10.7238 1.10508 10.6803 1.22995C10.6368 1.35483 10.6195 1.48735 10.6296 1.6192V2.3808C8.69067 2.59815 6.87127 3.42702 5.43484 4.74737C3.99842 6.06772 3.01955 7.81102 2.63999 9.7248L0.51919 18.8408C0.35647 19.5312 0.450933 20.2573 0.7849 20.8831C1.11887 21.509 1.66944 21.9916 2.33359 22.2408C3.78885 22.7754 5.28783 23.1826 6.81359 23.4576C6.81359 23.5216 6.80319 23.5856 6.80319 23.6496C6.795 24.2833 6.91274 24.9124 7.14958 25.5002C7.38642 26.088 7.73765 26.623 8.18289 27.074C8.62812 27.5251 9.15849 27.8832 9.74323 28.1276C10.328 28.372 10.9554 28.4979 11.5892 28.4979C12.223 28.4979 12.8504 28.372 13.4352 28.1276C14.0199 27.8832 14.5503 27.5251 14.9955 27.074C15.4407 26.623 15.792 26.088 16.0288 25.5002C16.2656 24.9124 16.3834 24.2833 16.3752 23.6496C16.3752 23.5864 16.36 23.5224 16.3568 23.4592C17.8834 23.1838 19.3832 22.7761 20.8392 22.2408C21.5039 21.9922 22.0552 21.5098 22.3898 20.8839C22.7244 20.258 22.8193 19.5316 22.6568 18.8408ZM11.5864 26.5576C10.8329 26.5515 10.1117 26.2511 9.57646 25.7207C9.04127 25.1903 8.7345 24.4718 8.72159 23.7184C9.67278 23.8266 10.6291 23.8837 11.5864 23.8896C12.5437 23.8837 13.5 23.8266 14.4512 23.7184C14.4383 24.4718 14.1315 25.1903 13.5963 25.7207C13.0611 26.2511 12.3399 26.5515 11.5864 26.5576ZM20.188 20.42C14.6366 22.4629 8.53934 22.4629 2.98799 20.42C2.76656 20.3367 2.58305 20.1756 2.47174 19.9668C2.36044 19.758 2.32896 19.5159 2.38319 19.2856L4.51039 10.1376C4.82 8.48384 5.699 6.99073 6.99476 5.91752C8.29052 4.84431 9.92121 4.25876 11.6037 4.26257C13.2862 4.26637 14.9142 4.85927 16.2051 5.93833C17.496 7.01739 18.3683 8.51446 18.6704 10.1696L20.7944 19.2856C20.8486 19.5159 20.8171 19.758 20.7058 19.9668C20.5945 20.1756 20.411 20.3367 20.1896 20.42H20.188Z"
                fill="#888888"
              />
              <path
                d="M22.6568 18.8408L20.54 9.75681C20.1647 7.8368 19.1871 6.08643 17.7492 4.75988C16.3113 3.43334 14.488 2.59969 12.544 2.38V1.6192C12.5541 1.48735 12.5368 1.35483 12.4933 1.22995C12.4498 1.10508 12.3809 0.990546 12.291 0.893533C12.2012 0.796521 12.0922 0.719121 11.971 0.66619C11.8498 0.613258 11.719 0.585938 11.5868 0.585938C11.4545 0.585938 11.3237 0.613258 11.2025 0.66619C11.0814 0.719121 10.9724 0.796521 10.8825 0.893533C10.7927 0.990546 10.7238 1.10508 10.6803 1.22995C10.6368 1.35483 10.6195 1.48735 10.6296 1.6192V2.3808C8.69067 2.59815 6.87127 3.42702 5.43484 4.74737C3.99842 6.06772 3.01955 7.81102 2.63999 9.7248L0.51919 18.8408C0.35647 19.5312 0.450933 20.2573 0.7849 20.8831C1.11887 21.509 1.66944 21.9916 2.33359 22.2408C3.78885 22.7754 5.28783 23.1826 6.81359 23.4576C6.81359 23.5216 6.80319 23.5856 6.80319 23.6496C6.795 24.2833 6.91274 24.9124 7.14958 25.5002C7.38642 26.088 7.73765 26.623 8.18289 27.074C8.62812 27.5251 9.15849 27.8832 9.74323 28.1276C10.328 28.372 10.9554 28.4979 11.5892 28.4979C12.223 28.4979 12.8504 28.372 13.4352 28.1276C14.0199 27.8832 14.5503 27.5251 14.9955 27.074C15.4407 26.623 15.792 26.088 16.0288 25.5002C16.2656 24.9124 16.3834 24.2833 16.3752 23.6496C16.3752 23.5864 16.36 23.5224 16.3568 23.4592C17.8834 23.1838 19.3832 22.7761 20.8392 22.2408C21.5039 21.9922 22.0552 21.5098 22.3898 20.8839C22.7244 20.258 22.8193 19.5316 22.6568 18.8408ZM11.5864 26.5576C10.8329 26.5515 10.1117 26.2511 9.57646 25.7207C9.04127 25.1903 8.7345 24.4718 8.72159 23.7184C9.67278 23.8266 10.6291 23.8837 11.5864 23.8896C12.5437 23.8837 13.5 23.8266 14.4512 23.7184C14.4383 24.4718 14.1315 25.1903 13.5963 25.7207C13.0611 26.2511 12.3399 26.5515 11.5864 26.5576ZM20.188 20.42C14.6366 22.4629 8.53934 22.4629 2.98799 20.42C2.76656 20.3367 2.58305 20.1756 2.47174 19.9668C2.36044 19.758 2.32896 19.5159 2.38319 19.2856L4.51039 10.1376C4.82 8.48384 5.699 6.99073 6.99476 5.91752C8.29052 4.84431 9.92121 4.25876 11.6037 4.26257C13.2862 4.26637 14.9142 4.85927 16.2051 5.93833C17.496 7.01739 18.3683 8.51446 18.6704 10.1696L20.7944 19.2856C20.8486 19.5159 20.8171 19.758 20.7058 19.9668C20.5945 20.1756 20.411 20.3367 20.1896 20.42H20.188Z"
                fill="black"
                fillOpacity="0.2"
              />
            </svg>
          </Badge>
        </Link>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          width: 360,
          p: 0,
          mt: 2.5,
          //  ml: 0.75
        }}
      >
        <Box sx={{ width: 360, display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{'اطلاعیه ها'}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {!data?.meta?.total ? `شما پیام خوانده نشده ندارید` : `شما ${data?.meta?.total} پیام خوانده نشده دارید`}
            </Typography>
          </Box>

          {data?.meta?.total > 0 && (
            <Tooltip title="خواندن همه">
              <IconButtonAnimate color="error" onClick={handleMarkAllAsRead}>
                {resQuery.isLoading ? (
                  <CircularProgress color="success" size={'12px'} />
                ) : (
                  <Iconify icon="eva:done-all-fill" width={20} height={20} />
                )}
              </IconButtonAnimate>
            </Tooltip>
          )}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {data?.meta?.total > 0 ? (
          <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
            <List
              disablePadding
              // subheader={
              //   <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
              //     جدید
              //   </ListSubheader>
              // }
            >
              {data?.data?.map?.((x) => (
                <NotificationItem data={x} onClick={() => handleMarkAsRead(x)} isLoading={resQuery.isLoading} />
              ))}
            </List>

            {/* <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Before that
              </ListSubheader>
            }
          >
            {notifications.slice(2, 5).map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List> */}
          </Scrollbar>
        ) : (
          ''
        )}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button
            onClick={handleClose}
            LinkComponent={Link}
            to={PATH_DASHBOARD.notification.root}
            fullWidth
            disableRipple
            color="success"
          >
            {`مشاهده همه`}
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}

// ----------------------------------------------------------------------

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.instanceOf(Date),
    id: PropTypes.string,
    isUnRead: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    avatar: PropTypes.any,
  }),
};

function NotificationItem({ data, onClick, isLoading }) {
  return (
    <ListItemButton
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(data.seen && {
          bgcolor: 'action.selected',
        }),
      }}
    >
      {/* <ListItemAvatar>
        <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar>
      </ListItemAvatar> */}
      <ListItemText
        primary={data?.notification?.message}
        sx={{
          pointerEvents: isLoading ? 'none' : '',
          opacity: isLoading ? '0.5' : '1',
        }}
        secondary={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: 'flex',
                alignItems: 'center',
                color: 'text.disabled',
              }}
            >
              <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
              {fToNow(data.created_at)}
            </Typography>
            <Tooltip sx={{ ml: 'auto' }} title="خوانده شد">
              <IconButtonAnimate disabled={isLoading} onClick={onClick}>
                {isLoading ? (
                  <CircularProgress color="success" size={'12px'} />
                ) : (
                  <Iconify color={'grey'} icon="eva:done-all-fill" width={20} height={20} />
                )}
              </IconButtonAnimate>
            </Tooltip>
          </Box>
        }
      />
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        &nbsp; {noCase(notification.description)}
      </Typography>
    </Typography>
  );

  return { title };
  // if (notification.type === 'order_placed') {
  //   return {
  //     avatar: (
  //       <img
  //         alt={notification.title}
  //         src="https://minimal-assets-api.vercel.app/assets/icons/ic_notification_package.svg"
  //       />
  //     ),
  //     title,
  //   };
  // }
  // if (notification.type === 'order_shipped') {
  //   return {
  //     avatar: (
  //       <img
  //         alt={notification.title}
  //         src="https://minimal-assets-api.vercel.app/assets/icons/ic_notification_shipping.svg"
  //       />
  //     ),
  //     title,
  //   };
  // }
  // if (notification.type === 'mail') {
  //   return {
  //     avatar: (
  //       <img
  //         alt={notification.title}
  //         src="https://minimal-assets-api.vercel.app/assets/icons/ic_notification_mail.svg"
  //       />
  //     ),
  //     title,
  //   };
  // }
  // if (notification.type === 'chat_message') {
  //   return {
  //     avatar: (
  //       <img
  //         alt={notification.title}
  //         src="https://minimal-assets-api.vercel.app/assets/icons/ic_notification_chat.svg"
  //       />
  //     ),
  //     title,
  //   };
  // }
  // return {
  //   avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
  //   title,
  // };
}
